import { SetContextLink } from "@apollo/client/link/context";

import { accessToken } from "./accessToken";

/** Attaches the Auth0 bearer token to a client built outside the React tree. */
export default function authLink(): SetContextLink {
    return new SetContextLink(
        async ({ headers }) => {
            const token = await accessToken();
            if (!token) return {};
            return { headers: { ...headers, Authorization: `Bearer ${token}` } };
        }
    );
}
